// extracted by mini-css-extract-plugin
export default {"external":"alquIQ","tabRoot":"blquIQ","tabDate":"clquIQ","tabDateActive":"dlquIQ"};